import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import { THREEDSNAPSHOT } from "csi/service/rightPaneService";
import { useStore } from "csi/state/hooks";
import { action } from "mobx";
import { observer } from "mobx-react-lite";
import React from "react";
import IconButton3D from "./IconButton3D";

const Snapshot = observer(() => {
	const rootStore = useStore();
	const { rightPaneStore, threeDStore } = rootStore;
	const { threeDTitle } = threeDStore;
	const { setSnapshot, allowSnapshots } = threeDStore.snapshotsStore;
	const { defaultVariantName } = threeDStore.canvasStore;
	const { threeDStore: { modelViewerStore } } = rootStore;

	if (!allowSnapshots) {
		return null;
	}

	const { 
		getSnapshotImage,
		getCanvasBlob,
		axisHelperVisible,
		toggleAxisHelper,
	} = modelViewerStore;
    
	const snapShotAction = action((img: string, file: File) => {
		const configuration =  defaultVariantName ? { variant: defaultVariantName } : undefined;
		const snapshotData = {
			img,
			file,
			isSelected: false,
			isGenerated: false,
			isVisible: true,
			configuration,
		};
		setSnapshot(snapshotData);
		rightPaneStore.setSelected(THREEDSNAPSHOT);
	});

	async function onClick() {
		if (axisHelperVisible) {
			toggleAxisHelper();
		}
		
		setTimeout(async () => {
			await getSnapshots();
		}, 100);
	}

	async function getSnapshots() {
		const image = await getSnapshotImage();
		const blob = await getCanvasBlob();
		const fileName = threeDTitle || "snapshot";
		const snapshotName = fileName.split(".")[0] + "_" + Date.now() + ".png";
		const file =  new File([blob], snapshotName, {
			type: "image/png",
		});
        
		snapShotAction(image, file);
	}

	return (
		<IconButton3D
			fontSize={17}
			onClick={onClick}
			res="3DViewSnapShot_TT"
		>
			<CameraAltOutlinedIcon />
		</IconButton3D>
	);
});

export default Snapshot;
